import { createAction } from 'typesafe-actions';
import { UnauthorizedError } from './types';

export const genericError = createAction('errors/GENERIC_ERROR')<string>();

export const unauthorizedError = createAction('errors/UNATHORIZED_ERROR')<UnauthorizedError>();

